import { ComponentProps } from './LoginPage';
import React from 'react';
const RegistrationPendingApproval: React.FC<ComponentProps> = ({ setActiveComponent }) => {
  return (
    <div className="p-5 leading-4">
      <div className="h-[90vh] d-flex align-items-center ">
        <div>
          <p className="text-xl text-red">Success</p>
          <p className="text-base leading-6 opacity-80">
            Thank you for submitting the information. Verification is in progress. We will send you a confirmation via
            email.
          </p>

          <button
            type="button"
            className="bg-purple border rounded text-white text-sm  h-[4vh] w-[6vw]"
            onClick={() => setActiveComponent('Login')}
          >
            Close
            {/* add loading spinner if needed */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPendingApproval;
